module.exports = __webpack_public_path__ + "img/com.codebeats.followers.10602706.png";